/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat2_TitleInputs */

const es_l6_feat2_title = /** @type {(inputs: L6_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo en un sitio`)
};

const gl_l6_feat2_title = /** @type {(inputs: L6_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo nun sitio`)
};

const en_l6_feat2_title = /** @type {(inputs: L6_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in one place`)
};

/**
* | output |
* | --- |
* | "Everything in one place" |
*
* @param {L6_Feat2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat2_title = /** @type {((inputs?: L6_Feat2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat2_title(inputs)
	if (locale === "en") return en_l6_feat2_title(inputs)
	return es_l6_feat2_title(inputs)
});